import React from 'react';
import { Grid, Button, Typography, Tooltip, Snackbar } from '@material-ui/core';
import FileCopyRounded from '@material-ui/icons/FileCopyRounded';
import DeleteRounded from '@material-ui/icons/DeleteRounded';

export const VideoListComponent = ({ 
    videos, 
    onCopyLink, 
    onDeleteVideo,
    snackBarOpen,
    setSnackBarOpen
}) => {
    if (!videos || videos.length === 0) {
        return null;
    }

    return (
        <>
            <Grid item style={{ 
                maxHeight: "250px", 
                overflowY: "scroll", 
                overflowX: "hidden", 
                border: '1px solid', 
                borderRadius: '10px', 
                padding: 10, 
                width: "1150px", 
                marginTop: "20px", 
                marginBottom: "20px" 
            }}>
                <Grid container>
                    {videos.map((videoUrl, index) => (
                        <Grid 
                            key={index}
                            item 
                            style={{ 
                                border: '1px solid', 
                                borderRadius: '5px', 
                                marginBottom: "5px", 
                                marginTop: "5px",
                                width: '100%'
                            }} 
                            container 
                            direction="row"
                        >
                            <Grid item xs={11}>
                                <Typography noWrap style={{ marginTop: 8, marginLeft: 5 }}>
                                    {videoUrl}
                                </Typography>
                            </Grid>
                            <Grid item container direction="row" xs={1} style={{ padding: 0, paddingRight: 10 }}>
                                <Grid item xs={6}>
                                    <Button onClick={() => onCopyLink(videoUrl)}>
                                        <Tooltip title="Copy video link">
                                            <FileCopyRounded />
                                        </Tooltip>
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button style={{ marginRight: 0 }}>
                                        <Tooltip title="Delete video">
                                            <DeleteRounded 
                                                style={{ color: "red" }} 
                                                onClick={() => onDeleteVideo(videoUrl)} 
                                            />
                                        </Tooltip>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Snackbar
                open={snackBarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackBarOpen(false)}
                message="Video link copied"
            />
        </>
    );
};